import React from 'react';

import CartSpecialOfferEntry from './CartSpecialOfferEntry';
import CartSpecialOfferDisplay from "./CartSpecialOfferDisplay";

export default function CartCouponTool({
  shoppingCart, callbacks, checkoutConfig, ...props
}) {
  const couponConfig = checkoutConfig?.coupons || {};

  // return empty div so layout is happy
  if (couponConfig.disabled)
    return <div></div>;

  const {specialOffer} = shoppingCart;

  function handleRemoveCoupon(_evt) {
    callbacks.updateCart({couponCode: ""});
  }

  if (specialOffer) {
    return <CartSpecialOfferDisplay
      handleRemoveCoupon={handleRemoveCoupon}
      offer={specialOffer}/>
  } else {
    return <CartSpecialOfferEntry
      shoppingCart={shoppingCart}
      callbacks={callbacks}
      {...props} />
  }
}
